module.exports = __webpack_public_path__ + "static/media/rightArrowHorse.e7e20254.svg";